<template>
  <div class="pa-0 ma-0">

    <v-row class="pa-0 ma-0">
      <v-col cols="12 text-left" class="pa-0 mt-3 mb-0">
        <h1 class="text-center">Atsumaritai</h1>
      </v-col>
    </v-row>

    <v-row class="pa-0 ma-0" align="center" justify="center">
      <v-col
        cols="12"
        md="6"
        class="mb-0 pb-0"
      >

<v-card
          id="right-display"
          width="100%"
          flat
        >
          <!-- class="text-box" -->
          <!-- v-if="analyticFlag" -->
          <v-card
            color="#ffffff"
            flat
            >

            <v-row class="mx-1">
                <v-col cols="12" class="text-right">
                  <!-- :disabled="analyticFlag" -->
                  <v-btn fab small dark v-on:click="openDialog" color="#002776">
                    <v-icon>mdi-format-list-bulleted-square</v-icon>
                  </v-btn>
                </v-col>
            </v-row>

            <!-- <div class="buttons"> -->
            <v-row justify="center">
              <v-col cols="6" md="4">
                <div class="text-center">
                  <v-progress-circular
                    rotate="360"
                    :size="circleSize"
                    width="3"
                    value="100"
                    color="#002776"
                  >
                    <span class="numberOfPeople">{{ numberOfPeople }}</span>
                  </v-progress-circular>
                  <p class="my-3 numberOfPeopleParagraph">このカメラの検知人数</p>
                </div>
              </v-col>

              <v-col cols="6" md="4">
                <div class="text-center">
                  <v-progress-circular
                    rotate="360"
                    :size="circleSize"
                    width="3"
                    value="100"
                    color="#002776"
                  >
                  <span class="numberOfPeople">{{ totalNumberOfPeople }}</span>
                  </v-progress-circular>
                  <p class="my-3 numberOfPeopleParagraph">全てのカメラの検知人数</p>
                </div>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" class="text-center">
                <v-btn v-on:click="start" v-if="!analyticFlag" fab dark color="#002776" class="mx-2">
                  <v-icon>mdi-play</v-icon>
                  <!-- <v-icon>arrow_back</v-icon> -->
                </v-btn>
                <v-btn v-on:click="stop" v-else color="#002776" fab dark class="mx-2">
                  <v-icon>mdi-pause</v-icon>
                </v-btn>

                <v-btn v-on:click="guiState.output.showVideo = !guiState.output.showVideo" fab outlined dark color="#002776" class="mx-2">
                  <v-icon v-if="guiState.output.showVideo">mdi-eye</v-icon>
                  <v-icon v-else>mdi-eye-off</v-icon>
                </v-btn>

                <v-btn v-on:click="changeCamera" v-if="cameraChangeFlag" :disabled="analyticFlag" fab outlined dark color="#002776" class="mx-2">
                  <v-icon>mdi-camera-retake-outline</v-icon>
                </v-btn>
              </v-col>

              <!-- <v-col cols="3" class="text-center">
              </v-col> -->

              <!-- v-if="cameraChangeFlag" -->
              <!-- <v-col cols="3" class="text-center">
              </v-col> -->
            </v-row>

            <!-- <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-subtitle class="text-center">全てのカメラの検知人数</v-list-item-subtitle>
                <v-list-item-title class="headline text-center">{{ totalNumberOfPeople }}人</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-subtitle class="text-center">このカメラの検知人数</v-list-item-subtitle>
                <v-list-item-title class="headline text-center">{{ numberOfPeople }}人</v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->

          </v-card>
        </v-card>

      </v-col>

      <v-col
        cols="12"
        md="6"
        class="mt-1 pt-1"
      >
        <v-card
          id="left-display"
          width="100%"
          height="100%"
          flat
          color="#24272a"
        >
          <div id="info"></div>
          <video id="video" playsinline muted autoplay style="display: none;"></video>
          <canvas id="output" class="canvasCorner"/>
        </v-card>        
      </v-col>
    </v-row>

      <v-dialog
        v-model="dialog"
        width="500"
      >
        <v-card>
          <v-row class="menu pa-0 ma-0">
            <v-col>
              <p class="text-center pa-0 ma-0">メニュー</p>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              v-if="uid"
              cols="12"
              class="text-center"
              >

              <v-row>
                <v-col class="text-center">
                  <p>{{ email }}</p>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12 text-center">
                  <v-btn min-width="200" href="https://atsumaritai-landing.web.app/" target="_blank" color="#002776" dark class="mx-2 my-0">
                    <v-icon left>mdi-open-in-new</v-icon>使い方
                  </v-btn>
                </v-col>

                <v-col cols="12 text-center">
                  <v-btn min-width="200" href="https://docs.google.com/forms/d/e/1FAIpQLSdEf575-8AKZuQiAJSR8IAhvPzcoNjB5JsrQi-Qse6nikiAPA/viewform?usp=sf_link" target="_blank" color="#002776" dark class="mx-2 my-0">
                    <v-icon left>mdi-open-in-new</v-icon>お問い合わせ
                  </v-btn>
                </v-col>

                <v-col cols="12 text-center">
                  <v-btn min-width="200" v-on:click="guide" color="#002776" dark class="mx-0 my-0">分析結果の公開方法</v-btn>
                </v-col>

                <v-col cols="12 text-center">
                  <v-btn min-width="200" v-on:click="signOut" color="#3e4d6b" small dark class="mx-0 my-0">ログアウト</v-btn>
                </v-col>

                <v-col cols="12 text-center">
                  <v-btn min-width="200" v-on:click="deleteDialog = true" color="#3e4d6b" small dark class="mx-o my-0">アカウント削除</v-btn>
                </v-col>
              </v-row>
            </v-col>
            
            <v-col
              v-else
              cols="12"
              >
              <v-row>
                <v-col cols="12 text-center">
                  <v-btn min-width="200" href="https://atsumaritai-landing.web.app/" target="_blank" color="#002776" dark class="mx-2 my-0">
                    <v-icon left>mdi-open-in-new</v-icon>使い方
                  </v-btn>
                </v-col>

                <v-col cols="12 text-center">
                  <v-btn min-width="200" href="https://docs.google.com/forms/d/e/1FAIpQLSdEf575-8AKZuQiAJSR8IAhvPzcoNjB5JsrQi-Qse6nikiAPA/viewform?usp=sf_link" target="_blank" color="#002776" dark class="mx-2 my-0">
                    <v-icon left>mdi-open-in-new</v-icon>お問い合わせ
                  </v-btn>
                </v-col>

                <v-col cols="12 text-center">
                  <v-btn min-width="200" v-on:click="signIn" color="#002776" dark class="mx-2 my-0 text-center">ログイン</v-btn>
                </v-col>

              </v-row>
            </v-col>
          </v-row>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="#002776"
              text
              @click="dialog = false"
            >
              閉じる
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="guideDialog"
        scrollable
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
        >
          <v-card>

            <v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="#002776"
                    text
                    @click="guideDialog = false"
                >
                    閉じる
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>

              <v-divider></v-divider>

              <p class="#002776 corner white--text pa-1">分析結果の公開方法</p>
              <p>
                自動生成されるサイトのURLを任意のサイトに貼り付けることで、本アプリでの計測結果を公開することができます。
              </p>

              <p>以下のテキストボックスに店名を入力して下さい。</p>
              <v-text-field
                filled
                v-model="shopName"
                label="店名"
              ></v-text-field>

              <p>以下のテキストボックスに店の最大収容人数を入力して下さい。</p>
              <v-text-field
                filled
                v-model="capacity"
                label="最大収容人数"
              ></v-text-field>

              <p>以下のURLを任意のサイトに貼り付けて下さい。</p>
              <v-text-field
                filled
                :value=siteUrl
              ></v-text-field>

              <v-divider></v-divider>

              <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="#002776"
                  text
                  @click="guideDialog = false"
              >
                  閉じる
              </v-btn>
              <v-spacer></v-spacer>
              </v-card-actions>
          </v-card-text>
          </v-card>
      </v-dialog>
        
      <v-dialog
        v-model="deleteDialog"
        max-width="290"
      >
        <v-card>
          <v-card-title class="headline">&nbsp;</v-card-title>

          <v-card-text class="text-center">
            アカウントを削除しますか？
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="#002776"
              text
              @click="deleteDialog = false"
            >
              いいえ
            </v-btn>

            <v-btn
              color="#002776"
              text
              @click="deleteAccount"
            >
              はい
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="videoErrorDialog"
        max-width="290"
      >
        <v-card>
          <v-card-title class="headline">&nbsp;</v-card-title>
            
          <v-card-text>
            <p>お使いのブラウザでは当サービスはご利用頂けません。</p>
            <p>以下のブラウザを推奨しています。</p>
            <ul>
              <li>iOS(iPhone) の方は Safari ブラウザ</li>
              <li>Android の方は Google Chrome ブラウザ</li>
            </ul>
            
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="#002776"
              text
              @click="videoErrorDialog=!videoErrorDialog"
            >
              はい
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>


      <v-dialog
        v-model="loadingDialog"
        max-width="290"
      >
        <v-card>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-progress-circular
              :size="50"
              color="#002776"
              indeterminate
              persistent
              class="ma-4"
            ></v-progress-circular>
            <v-spacer></v-spacer>
          </v-card-actions>

          <v-card-text class="text-center">
            <p>カメラのセットアップ中です...</p>
          </v-card-text>

        </v-card>
      </v-dialog>


  </div>
</template>

<script>
import * as posenet from '@tensorflow-models/posenet';
import { drawBoundingBox, drawKeypoints, drawSkeleton } from './utils.js';
// import { v4 as uuidv4 } from 'uuid';
import { db } from '../plugins/firebase';
import { auth } from '../plugins/firebase';

// const defaultResNetMultiplier = 1.0;
// const defaultResNetStride = 32;
// const defaultResNetInputResolution = 250;
let stream;

export default {
    data() {
      return {
        videoWidth: 0,
        videoHeight: 0,
        uid: null,
        email: null,
        analyticFlag: false,
        numberOfPeople: 0,
        totalNumberOfPeople: 0,
        getTimerId: null,
        updateTimerId: null,
        value:'',
        shopName: '',
        capacity: 10,
        queryRef: null,
        dialog: false,
        guideDialog: false,
        deleteDialog: false,
        videoErrorDialog: false,
        cameraChangeFlag: true,
        loadingDialog: true,
        circleSize: this.isMobile() ? 60 : 100,
        guiState: {
          algorithm: 'multi-pose',
          input: {
            architecture: 'MobileNetV1',
            outputStride: 16,
            inputResolution: 500,
            multiplier: this.isMobile() ? 0.50 : 0.75,
            quantBytes: 2
          },
          singlePoseDetection: {
            minPoseConfidence: 0.1,
            minPartConfidence: 0.5,
          },
          multiPoseDetection: {
            maxPoseDetections: 30,
            minPoseConfidence: 0.15,
            minPartConfidence: 0.1,
            nmsRadius: 30.0,
          },
          output: {
            showVideo: true,
            showSkeleton: true,
            showPoints: true,
            showBoundingBox: false,
          },
          net: null,
          front: true
        }
      }
    },
    methods: {
      stop() {
        this.analyticFlag = false
        clearInterval(this.getTimerId);
        clearInterval(this.updateTimerId);
        this.numberOfPeople = 0
        this.totalNumberOfPeople = 0
        // this.guiState.output.showVideo = true
      },
      async start() {
        await this.getAuth()
        if (!this.uid) return this.dialog = true

        this.analyticFlag = true
        // this.guiState.output.showVideo = false

        this.updateTimerId = setInterval(this.updateNumberOfPeople, 10000);
        this.getTimerId = setInterval(this.getNumberOfPeople, 10000);
      },
      async changeCamera() {
        this.loadingDialog = true
        this.guiState.front = !this.guiState.front
        if (typeof stream !== 'undefined') {
          await this.stopMediaTracks(stream);
        }
        await this.bindPage()
        this.loadingDialog = false
      },
      getNumberOfPeople() {
        const self = this
        let tmpNumberOfPeople = 0
        this.queryRef = db.collection('users')
                          .doc(this.uid)
                          .collection('numberOfPeople')
                          // .where('uid', '==', this.uid)
                          .where('timestamp', '>=', Date.now() - 10000)
                          .orderBy('timestamp', 'desc');

        this.queryRef.get()
          .then(snapshot => {
            // console.log('snapshot', snapshot)
            if (snapshot.empty) {
              console.log('No matching documents.');
              return;
            }
            snapshot.forEach(doc => {
              tmpNumberOfPeople = tmpNumberOfPeople + doc.data().numberOfPeople
            });
          })
          .then(() => {
            self.totalNumberOfPeople = tmpNumberOfPeople
          })
          .catch(err => {
            console.log('Error getting documents', err);
          });
      },
      updateNumberOfPeople() {
        // const self = this
        db.collection('users').doc(this.uid).collection('numberOfPeople').add({
          timestamp: Date.now(),
          // uid: this.uid,
          numberOfPeople: this.numberOfPeople
        })
      },
      isAndroid() {
        return /Android/i.test(navigator.userAgent);
      },
      isiOS() {
        return /iPhone|iPad|iPod/i.test(navigator.userAgent);
      },
      isMobile() {
        return this.isAndroid() || this.isiOS();
      },
      adjustVideo(video) {
        // const mobile = this.isMobile();
        this.videoWidth = document.getElementById('left-display').offsetWidth;
        console.log('this.videoWidth', this.videoWidth)
        const ratio = this.videoWidth / video.videoWidth;
        this.videoHeight = video.videoHeight * ratio;

        // video.width = mobile ? undefined : this.videoWidth;
        // video.height = mobile ? undefined : this.videoHeight;

        video.width = this.videoWidth;
        video.height = this.videoHeight;

      },
      async setupCamera() {
        const self = this
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
          throw new Error(
              'Browser API navigator.mediaDevices.getUserMedia not available');
        }

        const video = document.getElementById('video');

        stream = await navigator.mediaDevices.getUserMedia({
          'audio': false,
          'video': {
            facingMode: ( this.guiState.front ?  "user" : "environment" )
            // ,
            // width: mobile ? undefined : this.videoWidth,
            // height: mobile ? undefined : this.videoHeight,
          },
        })
        video.srcObject = stream;
        return new Promise((resolve) => {
          video.onloadedmetadata = () => {
            self.adjustVideo(video);
            resolve(video);
          };
        });
      },
      async loadVideo() {
        const video = await this.setupCamera();
        video.play()
        return video;
      },
      async bindPage() {
        const net = await posenet.load({
          architecture: this.guiState.input.architecture,
          outputStride: this.guiState.input.outputStride,
          inputResolution: this.guiState.input.inputResolution,
          multiplier: this.guiState.input.multiplier,
          quantBytes: this.guiState.input.quantBytes
        });

        let video;

        try {
          video = await this.loadVideo();
        } catch (e) {
          this.videoErrorDialog = true
          throw e;
        }
        this.guiState.net = net;
        this.detectPoseInRealTime(video);
      },
      stopMediaTracks(stream) {
        stream.getTracks().forEach(track => {
          track.stop();
        });
      },
      detectPoseInRealTime(video) {
        const canvas = document.getElementById('output');
        var ctx = canvas.getContext('2d');

        canvas.width = this.videoWidth;
        canvas.height = this.videoHeight;

        const self = this
        async function poseDetectionFrame() {
          // Begin monitoring code for frames per second
          let poses = [];
          let minPoseConfidence;
          let minPartConfidence;
          if (self.analyticFlag) {
            switch (self.guiState.algorithm) {
              case 'single-pose': {
                // const pose = await self.guiState.net.estimatePoses(video, {
                //   flipHorizontal: flipPoseHorizontal,
                //   decodingMethod: 'single-person'
                // });

                // poses = poses.concat(pose);
                // minPoseConfidence = +self.guiState.singlePoseDetection.minPoseConfidence;
                // minPartConfidence = +self.guiState.singlePoseDetection.minPartConfidence;
                break;
              }
              case 'multi-pose': {

                let all_poses = await self.guiState.net.estimatePoses(video, {
                  flipHorizontal: self.guiState.front,
                  decodingMethod: 'multi-person',
                  maxDetections: self.guiState.multiPoseDetection.maxPoseDetections,
                  scoreThreshold: self.guiState.multiPoseDetection.minPartConfidence,
                  nmsRadius: self.guiState.multiPoseDetection.nmsRadius
                });
                poses = poses.concat(all_poses);
                // console.log(poses)
                let posesLength = 0
                poses.forEach(({score}) => {
                  if (score >= 0.2) { return posesLength += 1 }
                })

                if (self.analyticFlag) { self.numberOfPeople = posesLength } 
                minPoseConfidence = +self.guiState.multiPoseDetection.minPoseConfidence;
                minPartConfidence = +self.guiState.multiPoseDetection.minPartConfidence;
                break;
              }
            }
          }

          ctx.clearRect(0, 0, self.videoWidth, self.videoHeight);

          ctx.save();
          if (self.guiState.front) {
            ctx.scale(-1, 1);
            ctx.translate(-self.videoWidth, 0);
          }

          if (self.guiState.output.showVideo) {
            ctx.drawImage(video, 0, 0, self.videoWidth, self.videoHeight);
          } else {
            ctx.fillStyle = "#000";
            ctx.fillRect(0, 0, self.videoWidth, self.videoHeight);
          }
          ctx.restore();

          if (self.analyticFlag) {
            poses.forEach(({score, keypoints}) => {

              if (score >= minPoseConfidence) {
                if (self.guiState.output.showPoints) {
                  drawKeypoints(keypoints, minPartConfidence, ctx);
                }
                if (self.guiState.output.showSkeleton) {
                  drawSkeleton(keypoints, minPartConfidence, ctx);
                }
                if (self.guiState.output.showBoundingBox) {
                  drawBoundingBox(keypoints, ctx);
                }
              }
            });
          }
          requestAnimationFrame(poseDetectionFrame);
        }
        poseDetectionFrame()
      },
      getAuth() {
        const self = this
        auth.onAuthStateChanged(function(user) {
            if (user) {
                self.uid = user.uid
                self.email = user.email
            }
        }, function(error) {
            console.log('error', error);
        });
      },
      signIn() {
        this.$router.push('login').catch((error)=>{ console.log( error )});
      },
      async signOut() {
        await auth.signOut()
        this.uid = null
        this.email = null
        this.$router.push('/login').catch((error)=>{ console.log(error)});
      },
      deleteAccount() {
        const self = this
        auth.currentUser.delete()
        .then(() => {
          self.$router.push('login').catch((error)=>{ console.log( error )});
        })
        .catch(function(error) {
          if (error.code == 'auth/requires-recent-login') {
            // The user's credential is too old. She needs to sign in again.
            auth.signOut().then(function() {
              // The timeout allows the message to be displayed after the UI has
              // changed to the signed out state.
              setTimeout(function() {
                alert('Please sign in again to delete your account.');
              }, 1);
            });
          }
        });
      },
      async openDialog() {
        await this.getAuth()
        this.dialog = true
      },
      guide() {
        this.dialog = false
        this.guideDialog = true
      },
    },
    computed: {
      embedJsCode: function() {
        if (!this.uid) return 'ログインするとここにコードが表示されます。'
        if (!this.capacity) return '店の最大収容人数を入れて下さい。'
        if (!Number.isInteger(Number(this.capacity))) return '店の最大収容人数は数字を入れて下さい。'
        return '<script src="https://asia-northeast1-atsumaritai.cloudfunctions.net/embedded?uid=' + this.uid
        + '&capacity=' + this.capacity
        + '"></' + 'script>'
      },
      embedHtmlCode: function() {
        if (!this.uid) return 'ログインするとここにコードが表示されます。'
        return '<span id="covid"></span>'
      },
      siteUrl: function() {
        if (!this.uid) return 'ログインするとここにコードが表示されます。'
        if (!this.shopName) return '店名を入れて下さい。'
        if (!this.capacity) return '店の最大収容人数を入れて下さい。'
        if (!Number.isInteger(Number(this.capacity))) return '店の最大収容人数は数字を入れて下さい。'
        return 'https://atsumaritai-satelite.web.app?uid='+ this.uid
                + '&shopName=' + this.shopName
                + '&capacity=' + this.capacity
      }
    },
    watch: {
    },
    async mounted() {

      const self = this
      await navigator.mediaDevices.getUserMedia({
        'audio': false,
        'video': {
          facingMode:  { exact: "environment" },
        },
      })
      .then((stream) => {
        self.guiState.front = false
        stream.getTracks().forEach(track => {
          track.stop();
        });
      })
      .catch((error) => {
        console.log(error)
        self.guiState.front = true
        self.cameraChangeFlag = false
      })
      await this.bindPage()
      this.loadingDialog = false
    },
    created() {
      this.loadingDialog = true
      window.addEventListener("orientationchange", ()=>{
        location.reload()
      });
      // .availHeight
      this.videoWidth = window.innerWidth;
      this.videoHeight = window.innerHeight;
    },
}

</script>

<style scoped>

.text-box {
  position:  absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  background-color:rgba(38,198,218,0.3);
}

.buttons {
  position:  absolute;
  top: 6px;
  left: 6px;
  /* transform: translate(-50%, -50%); */
  /* -webkit-transform: translate(-50%, -50%); */
  /* -ms-transform: translate(-50%, -50%); */
  /* background-color:rgba(240,240,240,0.5); */
}

.menu {
  background-color: #002776;
  color: #ffffff;
}

.corner {
  border-radius: 5px 5px;
  box-shadow: 1px 1px 1px rgba(0,0,0,0.4);
}

.canvasCorner {
  border-radius: 5px 5px;
}

.left-display {
  opacity: 0;
}

html, body {
  height: 100%;
  margin: 0;
  padding: 0;
}

h1 {
  font-family: 'Courier New', sans-serif;
  font-size: 1.2em;
  color: #ffffff;
}

p {
  font-family: "游ゴシック体", "YuGothic", "游ゴシック", "Yu Gothic", "メイリオ", sans-serif;
}

.numberOfPeople{
  /* font-size: 2em; */
  font-size: 0.8em;
}

.numberOfPeopleParagraph {
  font-size: 0.8em;
}

</style>
